import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { REQUISITES, SPECIAL_ASSESSMENT_OF_WORKING_CONDITIONS_DOCUMENT_LINK } from './constants'
import { messages } from './messages'
import './styles.scss'

const Requisites: React.FC = () => (
  <section className="requisites page-wrapper">
    <h2 className="requisites__title">{messages.title}</h2>
    {REQUISITES.map(requisite => (
      <div key={requisite.key} className="requisite">
        <span className="requisite__label">{requisite.label}</span>
        <span className="requisite__value">{requisite.value}</span>
      </div>
    ))}
    <div key="workingConditions" className="requisite">
      <span className="requisite__label">{messages.requisites.workingConditions.label}</span>
      <span className="requisite__value">
        <CommonLink
          className="underline underline_green color_green"
          url={SPECIAL_ASSESSMENT_OF_WORKING_CONDITIONS_DOCUMENT_LINK}
          shouldOpenInNewWindow
        >
          {messages.requisites.workingConditions.link}
        </CommonLink>
      </span>
    </div>
  </section>
)

export default Requisites
